import React from 'react'
import PropTypes from 'prop-types'
import { StepFinalText, StepFinalVar, StepFinalWrapper } from './StepFinalStyled'
import IMAGES from '../../images'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

const StepFinal = props => {
  const {
    textAlign,
    textLine1A,
    textLine1B,
    variableLine1,
    textLine2,
    textLine3,
    textLine4,
    buttonText,
    buttonLink,
    resetStep,
  } = props
  const navigate = useNavigate()
  const handleClickButton = () => {
    if (buttonLink?.length > 0) {
      navigate(buttonLink)
    }
    if (resetStep) {
      resetStep()
    }
  }

  return (
    <StepFinalWrapper>
      <img src={IMAGES.THANKS} alt={'thanks'} />
      {
        (textLine1A || textLine1B) &&
        <StepFinalText textAlign={textAlign}>
          {textLine1A && textLine1A}
          <StepFinalVar>{variableLine1}</StepFinalVar>
          {textLine1B && textLine1B}
        </StepFinalText>
      }
      {
        textLine2 &&
        <StepFinalText textAlign={textAlign}>
          {textLine2}
        </StepFinalText>
      }
      {
        textLine3 &&
        <StepFinalText textAlign={textAlign}>
          {textLine3}
        </StepFinalText>
      }
      {
        textLine4 &&
        <StepFinalText textAlign={textAlign}>
          {textLine4}
        </StepFinalText>
      }
      {
        buttonText &&
        <Button
          style={{ marginTop: 32 }}
          type={'primary'}
          onClick={handleClickButton}
        >
          {buttonText}
        </Button>
      }
    </StepFinalWrapper>
  )
}

StepFinal.propTypes = {
  textLine1A: PropTypes.node,
  variableLine1: PropTypes.node,
  textLine1B: PropTypes.node,
  textLine2: PropTypes.node,
  textLine3: PropTypes.node,
  textLine4: PropTypes.node,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  textAlign: PropTypes.string,
  resetStep: PropTypes.func,
}

export default StepFinal